import React, { useEffect, useRef, useState } from "react";
import { FaPlay, FaPause } from "react-icons/fa6";

const VoiceMessage = ({ audioSrc, duration, activeAudio, setActiveAudio }) => {
  const audioRef = useRef(new Audio(audioSrc));
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const audio = audioRef.current;

    const updateProgress = () => {
      if (audio.duration) {
        setProgress((audio.currentTime / audio.duration) * 100);
      }
    };

    audio.addEventListener("timeupdate", updateProgress);
    audio.addEventListener("ended", () => {
      setIsPlaying(false);
      setProgress(0);
      if (activeAudio === audio) {
        setActiveAudio(null);
      }
    });

    return () => {
      audio.removeEventListener("timeupdate", updateProgress);
      audio.removeEventListener("ended", () => {});
    };
  }, [activeAudio, setActiveAudio]);

  useEffect(() => {
    // Reset progress when a different audio starts playing
    if (activeAudio !== audioRef.current) {
      setIsPlaying(false);
      setProgress(0);
    }
  }, [activeAudio]);

  const togglePlay = () => {
    if (isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    } else {
      // Pause currently playing audio
      if (activeAudio && activeAudio !== audioRef.current) {
        activeAudio.pause();
        activeAudio.currentTime = 0; // Reset progress of the previous audio
      }

      // Play new audio
      audioRef.current.play();
      setIsPlaying(true);
      setActiveAudio(audioRef.current); // Update the active audio
    }
  };

  return (
    <div className="flex justify-between space-x-3">
      <button onClick={togglePlay}>{isPlaying ? <FaPause /> : <FaPlay />}</button>
      <div className="flex items-center space-x-1 relative w-full">
        {[...Array(15)].map((_, i) => (
          <div key={i} className={`w-0.5 h-4 bg-black ${isPlaying ? `animate-wave wave-delay-${i}` : ""}`} />
        ))}
        <div className="w-full rounded-md absolute">{isPlaying && <div className="h-7 bg-green-500 opacity-40 rounded-md transition-all" style={{ width: `${progress}%` }} />}</div>
      </div>
      <span className="mr-1">{duration}</span>
    </div>
  );
};

export default VoiceMessage;
